import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDropdownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';

import {
  DataGridCellDirective, DataGridDetailDirective, DataGridHeaderCellDirective
} from './data-grid-cell.directive';
import { DataGridComponent } from './data-grid.component';
import { GridCellHookDirective } from './grid-cell-hook.directive';
import { GridColumnDirective } from './grid-column.directive';
import { GridRowHookDirective } from './grid-row-hook.directive';

export { DataGridComponent } from './data-grid.component';
export { toGridColumns } from './data-grid.adapter';
export * from './data-grid.model';
export { GridColumnDirective } from './grid-column.directive';

/**
 * Import this wherever a <dx-data-grid> is being replaced. It is deliberately
 * self-contained (it pulls its own ng-zorro modules) so a feature module only
 * has to add DataGridModule, not the nine Nz* modules underneath it.
 */
@NgModule({
  declarations: [DataGridComponent, DataGridCellDirective, DataGridHeaderCellDirective,
                 DataGridDetailDirective, GridColumnDirective,
                 GridCellHookDirective, GridRowHookDirective],
  imports: [
    CommonModule, FormsModule,
    NzTableModule, NzInputModule, NzIconModule, NzButtonModule,
    NzCheckboxModule, NzDropdownModule, NzSelectModule, NzTagModule, NzTooltipModule,
  ],
  exports: [DataGridComponent, DataGridCellDirective, DataGridHeaderCellDirective,
            DataGridDetailDirective, GridColumnDirective,
                 GridCellHookDirective, GridRowHookDirective],
})
export class DataGridModule { }
